import { Link } from "react-router-dom";

const BLOCKS = [
  { t: "p", v: "In 2013, bourbon began disappearing from Buffalo Trace Distillery. Not just any bourbon. We're talking Pappy Van Winkle, one of the most sought-after names in American whiskey." },
  { t: "p", v: "When the investigation eventually led authorities to Toby Curtsinger, the story made national headlines." },
  { t: "p", v: "Stolen bourbon. Missing barrels. Backroom deals. A softball league. And a man who became known as the Bourbon King." },
  { t: "p", v: "It had all the makings of a Hollywood movie." },
  { t: "p", v: "But there's something about this story that I think deserves a little more understanding." },
  { t: "p", v: "Back then, there was a culture around bourbon that was very different from what we know today. Taking a bottle home, sharing bourbon with friends, or having access to whiskey that the rest of the world couldn't get wasn't necessarily viewed the same way by everyone working in the industry." },
  { t: "p", v: "That doesn't make it right. But it helps explain how the lines between what was tolerated and what was stealing could become blurred." },
  { t: "p", v: "And somewhere along the way, things got carried away." },
  { t: "p", v: "What might have started as a bottle here and there became something much bigger. Money entered the picture. Temptation grew. And as we sometimes say in the South, the devil got ahold of him." },
  { t: "p", v: "Toby made choices, and those choices had consequences." },
  { t: "p", v: "But I don't believe those choices should be the only thing that defines the rest of his life." },
  { t: "netflix" },
  { t: "p", v: "But a documentary can only tell so much." },
  { t: "p", v: "It can't capture every relationship, every conversation, every regret, or everything that happens after the cameras stop rolling." },
  { t: "p", v: "And that's where I think the story gets interesting." },
  { t: "q", v: "Because redemption isn't about pretending something didn't happen. It's about what you choose to do with your life after it does." },
  { t: "p", v: "I believe in accountability. I also believe in grace." },
  { t: "p", v: "And I believe a person can make some pretty terrible decisions and still have something good left to give the world." },
  { t: "p", v: "There's more to Toby Curtsinger than stolen bourbon." },
  { t: "p", v: "There's the man before the headlines, the man who lived through the consequences, and the man he has the opportunity to become." },
  { t: "p", v: "That's the story I'd like people to consider." },
  { t: "q", v: "Because sometimes the most important chapter isn't the one that made you famous. It's the one you write afterward." },
];

const Block = ({ b }) => {
  if (b.t === "q") {
    return <blockquote className="my-10 border-l-4 border-[#C9A24B] pl-6 font-display text-2xl font-semibold italic leading-snug text-[#1F1B17]">{b.v}</blockquote>;
  }
  if (b.t === "netflix") {
    return <p className="mt-5 text-lg leading-relaxed text-[#3A332C]">In 2021, Netflix introduced millions of viewers to Toby through its documentary series <em>Heist</em>. People watched the story of stolen Pappy Van Winkle, missing barrels, and a bourbon operation that had gotten completely out of hand.</p>;
  }
  return <p className="mt-5 text-lg leading-relaxed text-[#3A332C]">{b.v}</p>;
};

export default function StoryPage() {
  return (
    <main data-testid="story-page">
      <section className="on-dark bg-[#141210]">
        <div className="mx-auto grid max-w-6xl items-center gap-10 px-5 py-16 sm:px-8 md:grid-cols-[1.2fr_1fr] md:py-20">
          <div>
            <p className="eyebrow reveal">The Bourbon King</p>
            <h1 className="reveal reveal-2 mt-4 font-display text-4xl leading-[1.08] text-white sm:text-5xl lg:text-6xl">There's More to <em className="text-[#E8C878]">the Story</em></h1>
            <p className="reveal reveal-3 mt-6 text-lg font-bold text-[#E9E1D4]" data-testid="story-subtitle">You may know the heist. But do you know the man?</p>
          </div>
          <img src="/images/bk/toby-portrait.jpg" alt="Toby Curtsinger, the Bourbon King" className="reveal reveal-3 aspect-square w-full rounded-xl object-cover shadow-2xl" />
        </div>
      </section>
      <article className="mx-auto max-w-2xl px-5 py-16" data-testid="story-body">
        {BLOCKS.map((b, i) => <Block key={i} b={b} />)}
        <div className="mt-14 rounded-xl bg-[#141210] p-8 text-center">
          <p className="font-display text-2xl text-white">Hear it from Toby, in person.</p>
          <Link to="/" data-testid="story-events-button" className="mt-6 inline-block rounded border border-[#C9A24B] px-8 py-4 text-xs font-extrabold uppercase tracking-[0.2em] text-[#F3DDA4] transition-colors hover:bg-[#C9A24B] hover:text-[#141210]">See upcoming events</Link>
        </div>
      </article>
    </main>
  );
}
